export default (params) => ({
  trigger: {
    name: 'comparison_tool.remove_item_from_comparison',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'remove_item',
      params: {
        list: 'comparison',
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
